var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05634 0.75H67.9437C69.7697 0.75 71.25 2.2303 71.25 4.05634V67.9437C71.25 69.7697 69.7697 71.25 67.9437 71.25H4.05634C2.2303 71.25 0.75 69.7697 0.75 67.9437V4.05634C0.75 2.2303 2.2303 0.75 4.05634 0.75Z",
    fill: "#146EB4",
    fillOpacity: 0.1,
    stroke: "#146EB4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1577 24.379H29.7447V26.2325C28.5557 24.8686 26.877 24.0992 24.8837 24.0992C21.0018 24.0992 17.8544 26.9319 17.8544 31.4082C17.8544 35.7447 20.9319 38.6123 24.8837 38.6123C27.1218 38.6123 28.8704 37.773 29.9895 36.3042C30.549 37.773 31.9479 38.7173 34.0811 38.7173C38.6274 38.7173 40.2361 34.136 40.2361 30.2542C40.2361 22.5605 33.7314 17 25.7579 17C17.3648 17 11 23.0501 11 31.3033C11 39.6265 17.5047 45.5717 25.4432 45.5717C28.8354 45.5717 32.6123 44.4875 35.0603 42.5991L33.8363 40.6757C31.4233 42.4242 28.2059 43.3335 25.3733 43.3335C18.7637 43.3335 13.3781 38.2277 13.3781 31.2683C13.3781 24.344 18.6587 19.1682 25.7579 19.1682C32.4725 19.1682 37.8231 23.7495 37.8231 30.429C37.8231 33.2617 36.8439 36.549 34.4309 36.549C33.1719 36.549 32.1577 35.7797 32.1577 34.4857V24.379ZM25.2334 36.1643C22.8553 36.1643 20.6871 34.3808 20.6871 31.3733C20.6871 28.3657 22.8553 26.6171 25.2334 26.6171C27.6114 26.6171 29.7447 28.4007 29.7447 31.3733C29.7447 34.3458 27.6114 36.1643 25.2334 36.1643Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 56H11.5C11.2239 56 11 56.3358 11 56.75C11 57.1642 11.2239 57.5 11.5 57.5H62.5C62.7761 57.5 63 57.1642 63 56.75C63 56.3358 62.7761 56 62.5 56Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEmail);
export default __webpack_public_path__ + "static/media/active-email.d7ec4d953a0162ba66324b4db55834dc.svg";
export { ForwardRef as ReactComponent };